// extracted by mini-css-extract-plugin
module.exports = {"vjs-time-control":"timecontrols_vjs-time-control__2dHyw","video-js":"timecontrols_video-js__3iug0","vjs-current-time":"timecontrols_vjs-current-time__2mSbd"};